export const convertDateToNumber = (date) => {
    if (!date) return null;

    let d;

    // תאריך
    if (date instanceof Date) {
        d = date;
    }
    // timeStamp של firebase
    else if (typeof date.toDate === "function") {
        d = date.toDate();
    }

    // מחרוזת
    else if (typeof date === "string") {
        d = new Date(date);
    }

    // מספר
    else if (typeof date === "number") {
        return date;
    }

    else {
        console.warn("Unsupported date type:", date);
        return null;
    }

    return d.getTime();
};

export const extractNumber = (val) => {

    if (!val) return Infinity;
    const match = String(val).match(/\d+/);

    return match ? parseInt(match[0], 10) : Infinity;
};

export const formatDate = (date) => {
    if (!date) return '';

    let d;

    // תאריך
    if (date instanceof Date) {
        d = date;
    }
    // timeStamp של firebase
    else if (typeof date.toDate === "function") {
        d = date.toDate();
    }
    // מחרוזת
    else if (typeof date === "string") {
        // בדיקה אם המחרוזת בפורמט DD/MM/YYYY
        const ddmmyyyyPattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        const match = date.match(ddmmyyyyPattern);

        if (match) {
            // המרה מ-DD/MM/YYYY ל-MM/DD/YYYY עבור new Date
            const [, day, month, year] = match;
            d = new Date(`${month}/${day}/${year}`);
        } else {
            d = new Date(date);
        }
    }
    // מספר
    else if (typeof date === "number") {
        d = new Date(date);
    }
    else {
        console.warn("Unsupported date type:", date);
        return '';
    }

    // בדיקה אם התאריך תקין
    if (isNaN(d.getTime())) {
        console.warn("Invalid date value:", date);
        return '';
    }

    // פורמט dd/mm/yyyy
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
};

export const formatBoolean = (value) => {
    switch (value) {
        case "כן":
            return true;
        case "לא":
            return false;
        case "1":
            return true;
        case "0":
            return false;
        case 1:
            return true;
        case 0:
            return false;
        case "true":
            return true;
        case "false":
            return false;
        default:
            return value;;
    }
}

export const formatPhone = (phone) => {
    if (!phone) return '';
    if (phone.length === 10) {
        return `${phone.slice(0, 3)}-${phone.slice(3)}`;
    } else if (phone.length === 9) {
        return `${phone.slice(0, 2)}-${phone.slice(2)}`;
    } else {
        return phone;
    }
}

// פורמט זמן צפייה ל-HH:MM:SS או MM:SS
export const formatWatchTime = (seconds) => {
    const totalSeconds = Math.floor(seconds || 0);
    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    if (hours > 0) {
        return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    }
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};